export const environment = {
  apiUrl: 'https://the-byte-magazine.runasp.net/api',
  staticFilesUrl: 'https://the-byte-magazine.runasp.net/',
};
